import React from 'react';
import { Task } from '../../../../../types/task';
import { TaskCheckbox } from './index';

interface TaskCheckboxContainerProps {
  task: Task;
  onCheckboxClick: (e: React.MouseEvent) => void;
  checkboxColorClass: string;
  t: (key: string) => string;
  containerClassName: string; // 'items-start justify-center pt-3.5' vs 'items-center justify-center'
  additionalClassName?: string; // 支持FocusTaskItem的拖拽状态
}

/**
 * 任务复选框容器组件
 * 统一TaskItem和FocusTaskItem的复选框实现
 */
export const TaskCheckboxContainer: React.FC<TaskCheckboxContainerProps> = ({
  task,
  onCheckboxClick,
  checkboxColorClass,
  t,
  containerClassName,
  additionalClassName = ''
}) => {
  return (
    <button
      onClick={onCheckboxClick}
      className={`flex w-10 self-stretch focus:outline-none transition-all duration-200 ${containerClassName} ${additionalClassName}`}
      aria-label={task.done ? t('actions.markAsIncomplete') : t('actions.markAsComplete')}
    >
      {/* 圆圈 */}
      <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all duration-200 ${checkboxColorClass}`}>
        <TaskCheckbox isDone={task.done} />
      </div>
    </button>
  );
};
